<template>
  <div class="ant_block_skeleton">
    <div v-if="loading" class="ant-skeleton" :style="{width,height,padding,margin}"></div>
    <div v-show="!loading">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, default: "100%" },
    height: { type: String, default: "2rem" },
    padding: { type: String, default: "0" },
    margin: { type: String, default: "0" },
    loading: { type: Boolean, default: true }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>